import { IMessage } from '@common/types';
import { MarkdownRenderer } from '@components/markdown-renderer';
import AnswerMessageContainer from './answer-message-container';

interface ISimpleMessageResponseProps {
  message?: IMessage;
}

function SimpleResponse(props: ISimpleMessageResponseProps) {
  if (!props.message?.message) return null;

  return (
    <AnswerMessageContainer>
      <MarkdownRenderer content={props.message?.message} />
    </AnswerMessageContainer>
  );
}

export default SimpleResponse;
